import {useAuthStore} from "@stores/auth";
import {useCouponStore} from "@stores/coupon";
import {useBonusStore} from "@stores/bonus";

import { useFavoriteGameStore } from "@stores/favorite-games"

export default defineNuxtPlugin(async (nuxtApp) => {
  const authStore = useAuthStore(nuxtApp.$pinia);
  const couponStore = useCouponStore();
  const bonusStore = useBonusStore();
  const favoriteGameStore = useFavoriteGameStore();
  /**
   * @todo - move this await calls to init.server
   */
 
  if (authStore.isLoggedIn && !favoriteGameStore.state.favorite.length) {
    await favoriteGameStore.getFavorites();
  }

  const authToken = useCookie("jwt");
 

  // Verify user authentication
  if (authToken.value) {
    try {
      await authStore.getUser();

      if (!authStore.user) {
        authToken.value = null;
        authStore.state.isLoggedIn = false;
      }

      if (authStore.user?.id) {
        authStore.state.isLoggedIn = true;
      }
      // eslint-disable-next-line no-unused-vars
    } catch (error) {
      // getting a 401 will not crash nuxtServerInit
      // TO DO: Please fix me
    }
  }

    // Retrieve the user's necessary data
    if (authStore.isLoggedIn) {
        couponStore.getCoupons();
        bonusStore.getRollovers();
    }

    if (import.meta.server) {
      await authStore.getUserIp();
    }
});
